module.exports = __webpack_public_path__ + "static/media/tooltip.eb43540b.png";